import { axios } from "services";
import { UserActionTypes } from "./user.types";

export const LoginFailure = (errors) => ({
  type: UserActionTypes.LOGIN_FAILURE,
  payload: errors,
});

export const LoginSuccess = (data) => ({
  type: UserActionTypes.LOGIN_SUCCESS,
  payload: data,
});

export const clearLoggedIn = () => ({
  type: UserActionTypes.SIGN_OUT,
});

/**
 * Clear Redux auth state only (no network call). Used by the axios 401
 * interceptor, where we've already lost the session server-side and just
 * need the UI to reflect that.
 */
export const signOutLocal = () => (dispatch) => dispatch(clearLoggedIn());

/**
 * Full sign-out: clears the httpOnly session cookie on the backend, then
 * clears local Redux state.
 */
export const signOut = () => {
  return (dispatch) => {
    axios.post("/admin/logout").catch(() => {
      // Even if the network call fails, still clear local state below —
      // there's nothing more the user can do to retry a logout.
    });
    dispatch(clearLoggedIn());
  };
};

/**
 * Validate the current session by asking the backend whether the
 * httpOnly adminAccessToken cookie (if any) is still valid. Replaces the
 * old client-side "is there a token in localStorage/IndexedDB" check —
 * the cookie itself isn't readable from JS, so the backend has to confirm it.
 */
export const validateToken = (cb) => (dispatch) => {
  return axios
    .get("/admin/me")
    .then((response) => {
      const adminData = response?.data?.result?.adminData;
      if (adminData) {
        dispatch(LoginSuccess(adminData));
      } else {
        dispatch(clearLoggedIn());
      }
    })
    .catch(() => {
      // No valid session (401) or a network error — treat as signed out.
      dispatch(clearLoggedIn());
    })
    .finally(() => cb());
};
